<template>
  <div class="l_coupon">
    <div
      class="header"
      v-bind:style="{ 'padding-top': headerPaddingTop + 'px' }"
    >
      <div class="header_center">
        <img class="icon" src="@/assets/img/premium/icon.svg" />
      </div>
      <div class="header_end">
        <img src="@/assets/img/premium/close.svg" @click="__checkQuery()" />
      </div>
    </div>
    <div
      class="height_of_header"
      v-bind:style="{ 'padding-top': headerPaddingTop + 'px' }"
    >
      <div class="header_center"></div>
    </div>
    <div class="sub_title_wrapper">
      <img
        class="arrow_left"
        src="@/assets/img/premium/interlude_sub_title_arrow_left.png"
      />
      <p class="sub_title">プレミアムラウンジ会員専用のエリアです</p>
      <img
        class="arrow_right"
        src="@/assets/img/premium/interlude_sub_title_arrow_right.png"
      />
    </div>
    <div class="term">{{ limitDate }}</div>
    <router-link
      to="/faq/premium?showHeader=false"
      @click.native="
        () => {
          trapTrackEvent(1)
        }
      "
    >
      <div class="inner faq_icon">
        <img src="~@/assets/img/premium/faq.svg" />
      </div>
      <div class="inner faq" @click="tapFaqPremiumLounge()">
        <p class="tab">プレミアムラウンジって？</p>
      </div>
    </router-link>
    <!-- 絞り込みメニュー -->
    <TopMenu
      v-if="this.showTopMenu"
      :select="this.showItem"
      :freepass="this.existFreePass"
      @click="tapCondition"
    />
    <label
      for="foryou"
      class="foryou"
      v-if="this.isExistForYou && this.showItem === 'お知らせ'"
    >
      <input type="checkbox" id="foryou" v-model="checkForYou" />&nbsp;
      <span>「あなただけ」のお知らせのみ表示する</span>
    </label>

    <!-- 期限間近メッセージ -->
    <div v-if="this.showItem === 'クーポン'">
      <div class="expireMsg" v-if="this.isCouponExpire === 1">
        <div class="expire_coupon">
          <img src="@/assets/img/coupon/expire_coupon.png" />
        </div>
      </div>
    </div>
    <div v-if="this.showItem === 'フリーパス'">
      <div class="expireMsg" v-if="this.isFreePassExpire === 1">
        <div class="expire_coupon">
          <img src="@/assets/img/coupon/expire_freepass.png" />
        </div>
      </div>
    </div>

    <div v-show="!isNews() && !isTips()" class="container paddingtop">
      <!-- クーポンリスト -->
      <div
        class="list-coupon"
        v-for="(coupon, index) in currentCoupons"
        v-bind:key="`coupon_${index}`"
      >
        <FreepassCard
          v-show="isFreePass(coupon)"
          :couponId="
            coupon.data.coupon_id ? coupon.data.coupon_id : coupon.data.prize_id
          "
          :expireAt="coupon.data.expire_at"
          :category="coupon.data.coupon_category"
          :image="coupon.data.thumb_url"
          :title="coupon.data.caption"
          :headingSmall="coupon.data.heading_small"
          :headingLarge="coupon.data.heading_large"
          :type="coupon.data.type"
          :isHtml="coupon.data.is_html_display === '1'"
          :giftExpire="coupon.data.gift_expire"
          :isOff="coupon.data.is_off"
          :prize_type="coupon.data.prize_type"
          @click="
            () =>
              tapCoupon(
                coupon.data.coupon_id
                  ? coupon.data.coupon_id
                  : coupon.data.prize_id,
                coupon.data.caption
              )
          "
        />
        <CouponCard
          v-show="isCoupon(coupon)"
          :couponId="
            coupon.data.coupon_id ? coupon.data.coupon_id : coupon.data.prize_id
          "
          :category="coupon.data.coupon_category"
          :expireAt="coupon.data.expire_at"
          :image="coupon.data.thumb_url"
          :title="coupon.data.caption"
          :headingSmall="coupon.data.heading_small"
          :headingLarge="coupon.data.heading_large"
          :type="coupon.data.type"
          :isHtml="coupon.data.is_html_display === '1'"
          :giftExpire="coupon.data.gift_expire"
          :isOff="coupon.data.is_off"
          :imageSize="coupon.data.image_size"
          @click="
            () =>
              tapCoupon(
                coupon.data.coupon_id
                  ? coupon.data.coupon_id
                  : coupon.data.prize_id,
                coupon.data.caption
              )
          "
        />
      </div>
      <!-- 表示データが0件の場合 -->
      <div class="empty-coupon" v-if="this.currentCoupons.length < 1">
        <img src="../assets/img/premium/nocoupon.svg" alt="img_empty_coupon" />
        <p>現在ご利用可能な<br />クーポンはありません</p>
      </div>
    </div>
    <div v-show="isNews()" class="container paddingtop">
      <div v-if="this.currentNewsList">
        <!-- 重要情報 -->
        <important-information
          v-for="(item, index) in this.currentNewsList"
          :key="index"
          :id="item.id"
          :title="item.caption"
          :url="item.url"
          :isImportant="item.kind"
          @click="
            () => tapAction(item.id, item.url, item.caption, infoImportant)
          "
        />
        <!-- News情報 -->
        <div class="l_contents">
          <news-panel
            v-for="(item, index) in this.currentNewsList"
            :key="index"
            :url="item.url"
            :image="item.thumb_url"
            :title="item.caption"
            :date="item.date"
            :category="item.category_id"
            :isImportant="item.kind"
            :youtubeId="item.youtube_id"
            :isPremium="true"
            @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
          />
        </div>
      </div>
    </div>
    <div v-show="isTips()" class="container paddingtop">
      <div v-if="this.currentTipsList">
        <!-- 重要情報 -->
        <important-information
          v-for="(item, index) in this.currentTipsList"
          :key="index"
          :id="item.id"
          :title="item.caption"
          :url="item.url"
          :isImportant="item.kind"
          @click="
            () => tapAction(item.id, item.url, item.caption, infoImportant)
          "
        />
        <!-- 豆知識 -->
        <div class="l_contents">
          <news-panel
            v-for="(item, index) in this.currentTipsList"
            :key="index"
            :url="item.url"
            :image="item.thumb_url"
            :title="item.caption"
            :date="item.date"
            :category="item.category_id"
            :isImportant="item.kind"
            @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
          />
        </div>
      </div>
    </div>
    <template v-if="this.isUseAlert">
      <alert-coupon
        :image="this.currentCoupon.thumb_url"
        :type="this.currentCoupon.type"
        :isFreepass="true"
        @useCoupon="tapAcceptUseCoupon"
        @cancelCoupon="tapCancelUseCoupon"
      />
    </template>

    <!-- Popup背景  -->
    <div
      class="l_popup__cover animation_background"
      v-if="this.popups.length > 0"
    ></div>

    <!-- Popupパネル -->
    <home-popup
      v-for="(item, index) in this.popups"
      :key="`popup_${index}_${item.id}`"
      :id="item.id"
      :title="item.caption"
      :image="item.thumb_url"
      :isPopup="item.is_popup"
      @close="() => tapClose(item.id, item.caption)"
      @navigate="
        () => tapAction(item.id, item.url, item.caption, infoPopupDetail)
      "
    />

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
  </div>
</template>

<script>
import moment from 'moment'

import TopMenu from '@/components/PremiumTopMenu.vue'
import CouponCard from '@/components/PremiumCouponCard.vue'
import FreepassCard from '@/components/PremiumFreepassCard.vue'
import DateFormatter from '../utils/DateFormatter.js'

import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import AlertCoupon from '@/components/Modal/AlertCoupon'

import { mapActions, mapGetters } from 'vuex'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import { FactoryTrack, ContentsType } from '../constant/firebase'
import ImportantInformation from '@/components/Home/ImportantInformation.vue'
import NewsPanel from '@/components/NewsPanel.vue'
import HomePopup from '@/components/Modal/HomePopup.vue'

export default {
  name: 'Coupon',
  components: {
    TopMenu,
    CouponCard,
    FreepassCard,
    ErrorPopup,
    AlertCoupon,
    ImportantInformation,
    NewsPanel,
    HomePopup
  },
  data: function () {
    return {
      showItem: 'お知らせ',
      title: 'プレミアムラウンジ',
      apiType: '10',
      apiTypeFreepass: '7',
      apiTypeInfoList: '0',
      conditionQueryString: 'condition',
      condition: '2',
      currentCoupons: [],
      currentCoupon: null,
      isError: false,
      errorMessage: '',
      errorTitle: '',
      isUseAlert: false,
      infoNews: ContentsType.InfoNews,
      infoImportant: ContentsType.InfoImportant,
      infoPopupDetail: ContentsType.InfoPopupDetail,
      currentNewsList: [],
      currentTipsList: [],
      showTopMenu: false,
      existFreePass: false,
      headerPaddingTop: 10,
      headerHeight: 78,
      isExistForYou: false,
      checkForYou: false,
      isCouponExpire: 0,
      isFreePassExpire: 0
    }
  },
  computed: {
    ...mapGetters({
      coupons: 'Coupon/coupons',
      newsList: 'Home/allList',
      popups: 'Home/popups',
      stamp_year_start_at: 'User/stamp_year_start_at',
      selectedPremiumTab: 'PremiumTab/selectedPremiumTab'
    }),
    limitDate: function () {
      return this.stamp_year_start_at
        ? `${moment(this.stamp_year_start_at)
            .add(1, 'years')
            .format('YYYY/MM/DD')}まで入室可能`
        : '…'
    }
  },
  watch: {
    $route(to, from) {
      location.reload()
    },
    // popup表示している間はスクロール固定する、App.vueにisFixedが設定される
    popups: function (values) {
      const isFixed = values.length > 0
      this.action_ToggleModal(isFixed)
    },
    async conditionProp(val) {
      // update condition
      this.condition = this.conditionProp
    },
    newsList: function (val) {
      this.isExistForYou = val.some((item) => {
        return item.use_user_id === '1' && item.target_user_type !== '0'
      })
    },
    checkForYou: function (checked) {
      this.currentNewsList = this.newsList.filter((data) => {
        return (
          data.category_id !== '6' &&
          data.target_user_type !== '0' &&
          (checked ? data.use_user_id === '1' : true)
        )
      })
      console.log('current', this.currentNewsList)
    }
  },
  async created() {
    document.body.style.background = 'transparent'
    document.title = this.title // タイトル設定
    this.__checkQuertyCondition() // 条件取得
    const accTime = new DateFormatter().format(
      require('moment-timezone').tz('Asia/Tokyo')._d
    )
    try {
      window.receivedToken = (payload) => {
        const json = JSON.parse(payload)
        this.fetchInfoList(json.app_token, accTime, json.user_id)
        this.fetchCouponList(json.app_token, accTime, json.user_id)
        this.fetchUserData(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: this.apiType,
        acc_time: accTime
      })
    } catch (e) {
      this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
      this.errorMessage = ErrorMessage.MSG_ERROR_TOKEN
      this.isError = true
      console.log(e)
    }

    this.getHeaderPaddingTop()
    this.actionHideHeader()
  },
  mounted: function () {
    // 必ずページトップから始める
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 50)
    if (this.$route.query['coupon'] === '1') {
      this.showItem = 'クーポン'
    }
    if (this.selectedPremiumTab) {
      this.showItem = this.selectedPremiumTab
    }
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', [
      'actionCallCupon',
      'actionCallFreepass',
      'actionRequestToken',
      'asctionNavigateTo',
      'actionCallNewsDetail',
      'actionClosePremium',
      'actionShowHeader',
      'actionHideHeader',
      'actionRequestPaddingTop'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Coupon', [
      'actionFetchCoupon',
      'actionRequestExchangePrize'
    ]),
    ...mapActions('Home', [
      'action_FetchInfo',
      'action_SelectDetailNews',
      'action_DeletePopup'
    ]),
    ...mapActions('User', ['actionFetchUserData']),
    ...mapActions('PremiumTab', ['action_SetSelected']),
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQPremium())
          break
      }
    },
    tapAction(id, url, caption, type) {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoNews(id, caption, type))
      } catch (e) {
        console.log(e)
      }

      if (url !== '') {
        // external link
        this.navigateToRedirectDetail(id, url)
      } else {
        // internal link
        this.navigateToDetail(id, caption)
      }
    },
    tapFaqPremiumLounge() {
      this.actionShowHeader()
    },
    // URLがあれば、外部ページを詳細ページとして表示
    navigateToRedirectDetail(id, url) {
      this.actionToggleLoading(true)
      window.scrollTo(0, 0)
      this.updateLocalStorage(id)
      this.action_SelectDetailNews(id)
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 500)
      location.href = url
    },
    //  詳細ページへの遷移
    navigateToDetail(id, caption) {
      try {
        window.document.title = caption
        this.updateLocalStorage(id)
        this.action_SelectDetailNews(id)
        this.$router.push({
          name: 'HomeDetail'
        })
        this.actionShowHeader()
        // this.$router.push({ path: `/home/${id}` })
      } catch (e) {
        console.log(e)
      }
    },
    // クローズボタンを
    tapClose(id, caption) {
      this.trackEvent(FactoryTrack.createInfoPopupClose(id, caption))
      this.updateLocalStorage(id)
      this.action_DeletePopup(id)
    },
    // ローカルストレージデータの更新
    updateLocalStorage(id) {
      const key = 'news_' + id
      if (window.localStorage) {
        window.localStorage.setItem(key, 1)
      }
    },
    __checkQuery() {
      this.trackEvent(FactoryTrack.createClose('プレミアムラウンジ'))
      this.closePremium()
    },
    getHeaderPaddingTop() {
      // iPhone
      if (navigator.userAgent.indexOf('iPhone') > 0) {
        window.receivedTopPadding = (payload) => {
          const json = JSON.parse(payload)
          this.headerPaddingTop = json.paddingTop
        }
        this.actionRequestPaddingTop('premiumcoupon')
      }
    },
    closePremium() {
      this.actionClosePremium()
    },
    isFreePass(coupon) {
      return this.showItem === 'フリーパス' && coupon.data.prize_type !== '0'
    },
    isCoupon(coupon) {
      return this.showItem === 'クーポン' && coupon.data.prize_type === '0'
    },
    isNews() {
      return this.showItem === 'お知らせ'
    },
    isExistFreePass: function () {
      return this.currentCoupons.some((item) => item.data.prize_type !== '0')
    },
    isTips() {
      return this.showItem === '豆知識'
    },
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.action_ToggleModal(false)
      this.$router.go()
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.action_ToggleModal(false)
      this.isError = false
    },
    /**
     * お知らせデータを取得
     * @param {String} token
     * @param {String} accTime
     * @param {String} userId
     */
    async fetchInfoList(token, accTime, userId) {
      this.actionToggleLoading(true)
      try {
        await this.action_FetchInfo({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.currentInfos = this.data
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }
      // filter infolist with target_user_type to get premium infolist
      this.currentNewsList = this.newsList.filter(
        (data) => data.target_user_type !== '0' && data.category_id !== '6'
      )
      this.currentTipsList = this.newsList.filter(
        (data) => data.target_user_type !== '0' && data.category_id === '6'
      )
      this.actionToggleLoading(false)
    },
    /**
     * クーポンリストデータを取得
     * @param {String} token
     * @param {String} accTime
     * @param {String} userId
     */
    async fetchCouponList(token, accTime, userId) {
      this.actionToggleLoading(true)
      try {
        await this.actionFetchCoupon({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.currentCoupons = this.coupons
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }

      // filter couponlist with target_user_type to get premium couponlist
      this.currentCoupons = this.coupons.filter(
        (data) => data.data.target_user_type !== '0'
      )
      // fixed follow issue #111
      if (this.condition && this.condition === '2') {
        this.currentCoupons = this.coupons.filter(
          (data) => this.condition === data.data.coupon_category
        )
      }
      this.currentCoupons.forEach((part) => {
        const array = part.data.expire_at.split(' ')
        const dateStr = array[0].split('-').join('/')
        const date1 = new Date(Date.now())
        const date2 = new Date(dateStr)
        if ((date2 - date1) / 86400000 < 7) {
          if (part.data.prize_type !== '0') {
            this.isFreePassExpire = 1
          }
          if (part.data.prize_type === '0') {
            this.isCouponExpire = 1
          }
        }
      })
      this.existFreePass = this.isExistFreePass()
      this.showTopMenu = true
      this.actionToggleLoading(false)
    },
    // ユーザー情報を取得
    async fetchUserData(token, accTime, userId) {
      try {
        await this.actionFetchUserData({
          token: token,
          accTime: accTime,
          userId: userId
        })
      } catch (e) {
        console.log(e)
        if (this.errorType.length === 0) {
          this.errorType = 'user'
          this.errorMsg = e.message
          this.isError = true
        }
      }
      this.actionToggleLoading(false)
    },
    /**
     * クーポンのボタンタップ
     *
     * @param {string} id
     * @param {string} caption
     */
    tapCoupon(id, caption) {
      try {
        this.trackEvent(FactoryTrack.createCoupon(id, caption))
      } catch (e) {
        console.log(e)
      }
      if (window.navigator.onLine) {
        this.actionCallCupon(`${id}:confirm`)
      } else {
        console.log('off line')
        this.action_ToggleModal(true)
        this.errorMessage = '通信環境の良いところで、再度お試しください。'
        this.errorTitle = 'ネットワーククエラー'
        this.errorCode = '0000000'
        this.isError = true
      }
    },
    /**
     * クーポンのボタンタップ
     *
     * @param {string} id
     * @param {string} caption
     */
    tapFreepass(id, caption, imageUrl, type, coupon) {
      this.currentCoupon = coupon
      try {
        this.trackEvent(FactoryTrack.createFreepass(id, caption))
      } catch (e) {
        console.log(e)
      }
      this.isUseAlert = true
    },
    /**
     * ExchangePrizeをコール
     */
    async fetchExchangePrize(token, accTime, userId, prizeId) {
      this.actionToggleLoading(true)
      try {
        if (this.currentCoupon.used_count === 0) {
          await this.actionRequestExchangePrize({
            token: token,
            accTime: accTime,
            userId: userId,
            prizeId: prizeId
          })
        }
        if (window.navigator.onLine) {
          this.actionCallFreepass(`1-${prizeId}`)
        } else {
          console.log('off line')
          this.action_ToggleModal(true)
          this.errorMessage = '通信環境の良いところで、再度お試しください。'
          this.errorTitle = 'ネットワーククエラー'
          this.errorCode = '0000000'
          this.isError = true
        }
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.log(e)
      }
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 300)
    },

    /**
     * クーポン利用する承諾
     */
    tapAcceptUseCoupon() {
      try {
        this.trackEvent(
          FactoryTrack.createUseCoupon(
            this.currentCoupon.prize_id,
            this.currentCoupon.caption
          )
        )
      } catch (e) {
        console.log(this.currentCoupon)
      }
      this.isUseAlert = false
      const accTime = new DateFormatter().format(new Date())
      try {
        window.receivedToken = (payload) => {
          const json = JSON.parse(payload)
          this.fetchExchangePrize(
            json.app_token,
            accTime,
            json.user_id,
            json.prize_id
          )
          window.receivedToken = null
        }
        this.actionRequestToken({
          apiType: this.apiTypeFreepass,
          acc_time: accTime,
          prize_id: this.currentCoupon.prize_id.split('-')[1]
        }) // 特典
      } catch (e) {
        console.log(e)
        this.fetchUseCoupon('', '', '', '')
      }
    },
    /**
     * クーポン利用する拒否
     */
    tapCancelUseCoupon() {
      try {
        this.trackEvent(
          FactoryTrack.createCancelCoupon(
            this.currentCoupon.prize_id,
            this.coupon.caption
          )
        )
      } catch (e) {
        console.log(this.coupon)
      }
      this.isUseAlert = false
    },

    tapCondition(isSelect) {
      this.trackEvent(FactoryTrack.createCouponCondition(isSelect))
      this.action_SetSelected(isSelect)
      this.showItem = isSelect
    },
    /**
     * URLクエリパラメータを取得する
     */
    __checkQuertyCondition() {
      this.condition = this.$route.query[this.conditionQueryString]
    }
  }
}
</script>

<style lang="scss" scoped>
.paddingtop {
  padding-top: 16px;
}

.l_coupon:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100vh;
  background-image: url('~@/assets/img/premium/interlude_bg.png');
  background-size: 100%, auto;
  background-position: top;
}

.l_coupon > .container {
  text-align: left;
  margin-left: 14px;
  margin-right: 14px;

  padding-bottom: 40px;
  &.freepass {
    margin-left: 5px;
    margin-right: 5px;
  }
}
.foryou {
  color: #c0a417;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.l_coupon > .container > .empty-coupon {
  text-align: center;
  position: fixed;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.l_coupon > .container > .empty-coupon > p {
  font-size: 16px;
  line-height: 1.38;
  text-align: center;
  color: #999999;
  margin-top: 10px;
}

.sub_title_wrapper {
  height: 20px;
  display: flex;
  justify-content: center;
  margin: 10px 0;

  img {
    height: 100%;
  }

  .sub_title {
    color: #c0a417;
    font-size: 3.5vw;
    font-weight: bold;
  }

  .arrow_left {
    margin-right: 7px;
  }

  .arrow_right {
    margin-left: 7px;
  }
}

// .sub_title:before {
//   content: url('~@/assets/img/premium/interlude_sub_title_arrow_left.png');
//   padding-right: 4px;
//   height: 100%;
// }

// .sub_title:after {
//   content: url('~@/assets/img/premium/interlude_sub_title_arrow_right.png');
//   padding-left: 4px;
// }

.term {
  color: #f2e7b4;
  font-weight: bold;
  background-image: url('~@/assets/img/premium/lounge_kigenwaku.png');
  background-size: contain;
  background-position: center;
  padding: 8px;
  margin: 10px;
  background-repeat: no-repeat;
  font-size: 4vw;
}

.faq {
  color: #c0a417;
  font-size: 11px;
  font-weight: bold;
  border: #c0a417;
  text-decoration: underline;
  text-decoration-color: #c0a417;
}

.faq_icon {
  margin-top: 4px;
  margin-right: 2px;
}

.icon {
  margin-left: 10px;
  margin-right: 10px;
}

.header {
  padding-bottom: 10px;
  border-bottom: solid 1px #c0a417;
  position: fixed;
  z-index: 1;
  background-image: url('~@/assets/img/premium/interlude_bg.png');
  background-size: 100%, auto;
  background-position: top;
}

.height_of_header {
  padding-bottom: 26px;
}

.header_start {
  height: auto;
  text-align: center;
  display: inline-block;
}

.header_center {
  width: 82%;
  height: auto;
  display: inline-block;
}

.text {
  width: 82%;
  height: auto;
}

.header_end {
  width: 14%;
  height: auto;
  display: inline-block;
}

.inner {
  display: inline-block;
  vertical-align: middle;
}

.expireMsg {
  position: relative;
  width: 100%;
  height: 46px;
  background-color: #fde7e7;
}
.expire_coupon {
  position: relative;
  width: 65%;
  height: 40px;
  top: 0.8em;
  left: 4em;
}

.expire_coupon img {
  width: 100%;
  height: auto;
}
</style>
